<template>
  <div>
    
  <inertia-head >
    <title>{{meta_title}}</title>
    <meta name="description" :content="$page.props.global_config.general.meta_desc">
    <link rel="shortcut icon" :href="$page.props.global_config.general.favicon" type="image/x-icon">
    <link rel="icon" :href="$page.props.global_config.general.favicon" type="image/x-icon">
  </inertia-head >
    <jet-banner />

    <nav class="navbar navbar-expand-md navbar-light bg-white border-bottom sticky-top py-2 ">
      <div class="container">
        <!-- Logo -->
        <inertia-link class="navbar-brand mr-4" :href="route('landing')">
          <img :src="$page.props.global_config.general.website_logo" style="max-height:80px"/>
        </inertia-link>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <!-- Left Side Of Navbar -->
          <ul class="navbar-nav">
            <jet-nav-link :href="route('landing')" >
              Home
            </jet-nav-link>

            <jet-nav-link :href="route('products')" >
              Products
            </jet-nav-link >

            <jet-nav-link :href="route('about')" >
              About Us
            </jet-nav-link >

      

          </ul>
      
          <ul class="navbar-nav ml-auto">
            <!-- Authentication Links -->
            <jet-dropdown id="settingsDropdown" v-if="$page.props.isLogin">
              <template #trigger>
                <img v-if="$page.props.jetstream.managesProfilePhotos" class="rounded-circle" width="32" height="32" :src="$page.props.user.profile_photo_url" :alt="$page.props.user.name" />

                <span v-else>
                  {{ $page.props.user.name }}

                  <svg class="ml-2" width="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd" />
                  </svg>
                </span>
              </template>

              <template #content>
                <jet-dropdown-link @click="openPayrecon()" v-if="$page.props.isLogin && $page.props.is_payrecon === true">
                  View Added Products
                </jet-dropdown-link>
                <!-- Account Management -->
                <jet-dropdown-link :href="route('profile.show')" v-if="$page.props.isLogin && $page.props.is_payrecon === false">
                  Profile
                </jet-dropdown-link>

                <jet-dropdown-link :href="route('api-tokens.index')" v-if="$page.props.jetstream.hasApiFeatures && $page.props.permissions.indexOf('api') !== -1">
                  API Tokens
                </jet-dropdown-link>

                <jet-dropdown-link :href="route('admin.config')" :active="route().current('admin.config')" v-if="$page.props.isLogin && $page.props.permissions.indexOf('configuration') !== -1">
                  Configuration
                </jet-dropdown-link>

                 <jet-dropdown-link :href="route('admin.setting')" :active="route().current('admin.setting')" v-if="$page.props.isLogin && $page.props. permissions.indexOf('setting') !== -1 ">
                 Setting
                </jet-dropdown-link>

                <hr class="dropdown-divider">

                <!-- Authentication -->
                <form @submit.prevent="logout">
                  <jet-dropdown-link as="button">
                    Log out
                  </jet-dropdown-link>
                </form>
              </template>
            </jet-dropdown>

             <template v-else>
              <jet-nav-link :href="route('login.payrecon')" class="text-muted" :active="route().current('login.payrecon')">
                Log in Payrecon
              </jet-nav-link>

              <!--jet-nav-link :href="route('register')" class="text-muted" :active="route().current('register')">
                Register 
              </jet-nav-link-->
            </template>

          </ul>
        </div>
      </div>
    </nav>


    <!-- Page Heading -->
    <header class="d-flex py-3 " style="background-color:#fbfbfb;" v-if="hasHeadingSlot">
      <div class="container text-muted">
        <slot name="header"></slot>
      </div>
    </header>

    <div  style="min-height:calc(100vh - 130px);">
        <!-- Fluid Content -->
        <main class="container-fluid p-0" v-if="hasFluidSlot">
          <slot name="fluid"></slot>
        </main>
      
      
        <!-- Default container eContent -->
        <main class="container py-5" v-if="hasDefaultSlot" >
            <slot></slot>
        </main>
    </div>

    <!-- footer -->
    <template-footer />
  </div>
</template>

<script>
import JetApplicationLogo from '@/Jetstream/ApplicationLogo'
import JetBanner from '@/Jetstream/Banner'
import JetApplicationMark from '@/Jetstream/ApplicationMark'
import JetDropdown from '@/Jetstream/Dropdown'
import JetDropdownLink from '@/Jetstream/DropdownLink'
import JetNavLink from '@/Jetstream/NavLink'
import TemplateFooter from '@/Layouts/TemplateFooter'


export default {
  components: {
    JetApplicationLogo,
    JetBanner,
    JetApplicationMark,
    JetDropdown,
    JetDropdownLink,
    JetNavLink,
    TemplateFooter,
  },

  data() {
    return {
      showingNavigationDropdown: false,
    }
  },

  methods: {
    switchToTeam(team) {
      this.$inertia.put(route('current-team.update'), {
        'team_id': team.id
      }, {
        preserveState: false
      })
    },

    logout() {
      this.$inertia.post(route('logout'));
    },
    openPayrecon(){
      if(this.$page.props.payrecon_app) window.open(`${this.$page.props.payrecon_app}/products/dropship-list`);
    }
  },

  computed: {
    path() {
      return window.location.pathname
    },

    hasHeadingSlot() {
        return this.$slots['header']
    },
    hasFluidSlot() {
        return this.$slots['fluid']
    },
     hasDefaultSlot () {
      return !!this.$slots.default
    },
    meta_title(){
      const title = this.$page.props.global_config.general.meta_title ?? 'My Webstore'
      return this.title ? `${this.title} - ${title}` : title
    }
  },
  props: {
    isLogin: Boolean,
    categories: Array,
    roles: Array,
    config: Array,
    title: String,
  }
}
</script>
